import type React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VisitorsList } from '@widgets/events/visitors-list';
import { Search } from '@features/common';
import { ActionsButton, ActionsModal, SelectAllButton } from '@features/events/event-visitors';
import { VisitorCard } from '@features/events/event-visitors/visitor-card';
import { ArrowShortLeft, Mark } from '@shared/assets';
import { formatPhoneNumber } from '@shared/helpers';
import { IconButton, ListBody, PageHead, PageTitle } from '@shared/ui';
import { type TicketDetail } from '@src/library/models/events';
import { Blank, Loader } from 'library/components/common';
import { useVisitors } from 'library/hooks/events';
import * as st from './styles.module.scss';

/**
 * TODO: Вернуть закомментированный компонент аватара, после изменения api
 */

export const EventVisitors: React.FC = () => {
  const [isSelectionOn, setSelection] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenSearch, setOpenSearch] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState<TicketDetail[]>([]);
  const { id } = useParams<{ id: string }>();

  const { tickets, onClose, search, handleSearch, status, lastElement } = useVisitors(id);
  const ticketsTitles = tickets.map(
    (ticket) => `${ticket.last_name} ${ticket.first_name} ${ticket.middle_name}`
  );

  useEffect(() => {
    if (isSelectAll) {
      setSelectedTickets(tickets);
    }
  }, [isSelectAll]);

  const onActions = () => {
    setIsOpenModal((prev) => !prev);
  };

  const handleClickSelectTicket = (ticket: TicketDetail) => {
    const isSelected = selectedTickets.includes(ticket);
    const updateTickets = isSelected
      ? selectedTickets.filter((selectTicket) => selectTicket.id !== ticket.id)
      : [...selectedTickets, ticket];

    setSelectedTickets(updateTickets);
  };

  const handleClickSelectedAll = () => {
    setSelectAll((prev) => !prev);
  };

  const handleClickSwitchSelection = () => {
    if (isSelectionOn) {
      setSelectedTickets([]);
    }
    setSelection((prev) => !prev);
  };

  return (
    <>
      <PageTitle title="Участники мероприятия" />

      <PageHead
        Left={
          <IconButton variant="dark" onClick={onClose}>
            <ArrowShortLeft />
          </IconButton>
        }
        Right={
          <>
            {isSelectionOn && selectedTickets.length === 0 && (
              <SelectAllButton onSelected={handleClickSelectedAll} />
            )}
            {selectedTickets.length > 0 && <ActionsButton onClick={onActions} />}
            <Search
              search={search}
              onSearch={handleSearch}
              titles={ticketsTitles}
              isLoading={status === 'loading'}
              onToggle={() => setOpenSearch((prev) => !prev)}
            />
            {!isOpenSearch && (
              <IconButton
                className={`${isSelectionOn && st.checkbox}`}
                variant={isSelectionOn ? 'active' : 'dark'}
                onClick={handleClickSwitchSelection}
              >
                <Mark />
              </IconButton>
            )}
          </>
        }
      />

      <ListBody>
        <VisitorsList
          ticketsList={tickets}
          isSelectionOn={isSelectionOn}
          onSelectedTicket={handleClickSelectTicket}
          selectedTickets={selectedTickets}
        />

        {status === 'loaded' && !tickets.length && (
          <Blank text={search ? 'Не найдено ни одного посетителя' : 'Нет посетителей'} />
        )}

        {status === 'loading' && !tickets.length && <Loader text="Загрузка билетов..." />}

        <div ref={lastElement} style={{ height: '60px' }} />
      </ListBody>

      <ActionsModal isOpen={isOpenModal} onToggle={onActions} />
    </>
  );
};
